export default __webpack_public_path__ + "static/media/group3.e7c1db50.png";